(function () {
  const PROMO_PARAM_KEY = "promo";
  const UTM_PARAM_KEY = "utm_source";
  const UTM_CAMPAIGN_KEY = "utm_campaign";
  const AIC_KEY = "aic";
  const REFERRAL_VALUE = "referral";
  const RESET_PARAM_KEY = "reset_storage";

  const PROMO_STORAGE_KEY = "promo";

  const params = new URLSearchParams(window.location.search);

  if (params.get(RESET_PARAM_KEY) === "true") {
    localStorage.removeItem(PROMO_STORAGE_KEY);
    return;
  }

  function getReferralPromoValue() {
    const utmCampaign = params.get(UTM_CAMPAIGN_KEY);
    if (utmCampaign) {
      const match = utmCampaign.match(/_(\d+)$/);
      return match ? match[1] : utmCampaign;
    }

    const aic = params.get(AIC_KEY);
    if (aic) return aic;

    return null;
  }

  function storePromoTemporarily(value) {
    localStorage.setItem(
      PROMO_STORAGE_KEY,
      JSON.stringify({
        value,
        timestamp: Date.now()
      })
    );
  }

  let resolvedPromo = null;

  if (params.has(PROMO_PARAM_KEY)) {
    resolvedPromo = params.get(PROMO_PARAM_KEY);
  }
  else if (params.get(UTM_PARAM_KEY) === REFERRAL_VALUE) {
    resolvedPromo = getReferralPromoValue();
  }

  if (resolvedPromo) {
    storePromoTemporarily(resolvedPromo);
  }
})();

(function () {
  const PROMO_MESSAGES = {
    "116005": "GET A FREE INTRO BOX",
    "121196": "Sizzle Society Exclusive - Claim Your Free Box"
  };

  async function getPromo() {
    const raw = localStorage.getItem("promo");
    if (!raw) return null;

    try {
      return JSON.parse(raw).value;
    } catch {
      return null;
    }
  }

  async function updateBar() {
    const promo = await getPromo();
    if (!promo) return;

    const message = PROMO_MESSAGES[promo];

    if (!message) return;

    const el = document.querySelector(".announcement-bar__message");
    if (el) el.textContent = message;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateBar);
  } else {
    updateBar();
  }
})();
